var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.032 14.8998C11.0696 14.8998 14.372 9.97468 14.372 5.70413C14.372 5.56393 14.372 5.42479 14.3624 5.28616C15.0048 4.82933 15.5592 4.26212 16 3.61312C15.4016 3.87461 14.7656 4.0461 14.1152 4.12171C14.8 3.71765 15.3128 3.08286 15.5584 2.33382C14.9136 2.71031 14.2088 2.97602 13.4736 3.11858C12.2304 1.81741 10.1512 1.75437 8.8288 2.97835C7.9768 3.76756 7.6144 4.94426 7.8792 6.06663C5.24 5.93589 2.7808 4.70877 1.1136 2.69007C0.2424 4.16688 0.688 6.05543 2.1304 7.00374C1.608 6.98877 1.0968 6.8503 0.64 6.59983V6.64085C0.6408 8.17911 1.7424 9.50362 3.2736 9.80843C2.7904 9.93839 2.2832 9.95723 1.792 9.86351C2.2216 11.1804 3.4544 12.0824 4.8584 12.1084C3.696 13.0079 2.26 13.4963 0.7816 13.4948C0.5208 13.494 0.26 13.479 0 13.4483C1.5016 14.3966 3.248 14.8999 5.032 14.8975",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ec0aa281e627bc98e36d087c165b020c.svg";
export { ForwardRef as ReactComponent };